<template>
  <div class="step-tab">
    <div class="cp-card">
      <p class="cp-hint">{{ L.options_step_hint || 'The Options step shows base services, upsells and insurances from Nezasa. The only profile-configurable box is the insurance-confirmation below.' }}</p>
      <BoxVisibilityToggle
          :boxVisibility="profile.box_visibility"
          boxKey="insurance_confirm"
          :label="L.review_box_insurance_confirm || 'Insurance confirmation'"
          :hint="L.box_toggle_insurance_confirm_hint || 'Replaces the insurance offer list with a single confirmation checkbox.'" />
    </div>

    <PreviewFrame :label="L.preview || 'Preview'">
      <OptionsPreview :texts="text" :rich="richHtml" :lang="lang" :brandColor="brandColor" :boxVisibility="profile.box_visibility" />
    </PreviewFrame>
  </div>
</template>

<script>
import PreviewFrame from './previews/PreviewFrame.vue'
import OptionsPreview from './previews/OptionsPreview.vue'
import BoxVisibilityToggle from './BoxVisibilityToggle.vue'

/**
 * Options step tab: only the insurance-confirmation box is profile-configurable
 * (show/hide). The confirmation text is edited on the Terms tab; here the admin
 * decides whether the box appears, with a live preview.
 */
export default {
  name: 'StepTabOptions',
  components: { PreviewFrame, OptionsPreview, BoxVisibilityToggle },
  props: {
    options: { type: Object, required: true },
    profile: { type: Object, required: true },
    text: { type: Object, default: () => ({}) },
    richHtml: { type: Object, default: () => ({}) },
    lang: { type: String, default: 'de' },
    brandColor: { type: String, default: '#1a73e8' }
  },
  computed: {
    L() { return this.options.Lang || {}; }
  }
};
</script>

<style scoped>
.step-tab { animation: cp-fade .2s ease; }
@keyframes cp-fade { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: translateY(0); } }
.cp-card { background: #fff; border-radius: 1rem; box-shadow: 0 2px 12px rgba(0,0,0,0.06); padding: 1.5rem 1.75rem; }
.cp-hint { font-size: 0.8rem; color: #888; margin: 0 0 1rem; max-width: 620px; }
</style>
